"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
exports.default = (0, react_intl_1.defineMessages)({
    msgEditableTableInputLabel: {
        id: 'apps.editableTable.input.label',
        defaultMessage: 'Input Table (optional)',
    },
    msgEditableTableInputPlaceholder: {
        id: 'apps.editableTable.input.placeholder',
        defaultMessage: 'Select the variable with the DataFrame to use as input table',
    },
});
//# sourceMappingURL=apps.js.map